export const makeSelector = (cssClass: string): string => {
    return `.${cssClass}`;
};
